import API from "../API/newIndex";

export const uploadTextEditorImage = async (file) => {
  const result = await API({
    url: "/admin/fileupload/upload",
    method: "POST",
    data: file,
  });
  if (result?.data?.data?.length > 0) {
    return result.data.data[0];
  }

  throw new Error("Image upload failed");
};

export const scrollToFirstError = (fieldName) => {
  setTimeout(() => {
    let element = null;

    if (fieldName) {
      element =
        document.querySelector(`[name="${fieldName}"]`) ||
        document.getElementById(`custom-field-${fieldName}`) ||
        document.getElementById(`custom-field-container-${fieldName}`) ||
        document.getElementById(fieldName) ||
        document.querySelector(`[id*="${fieldName}"]`);
    }

    if (!element) {
      element =
        document.querySelector('.border-\\[var\\(--color-danger\\)\\]') ||
        document.querySelector('.border-red-500') ||
        document.querySelector('[class*="border-red"]') ||
        document.querySelector('[class*="color-danger"]');
    }

    if (element) {
      // If the field is inside a closed <details> accordion card, automatically expand it
      const parentDetails = element.closest('details');
      if (parentDetails && !parentDetails.open) {
        parentDetails.open = true;
      }

      // Smooth scroll into view
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Focus the input if focusable
      const focusable =
        element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.tagName === 'SELECT'
          ? element
          : element.querySelector('input, textarea, select');

      if (focusable && typeof focusable.focus === 'function') {
        setTimeout(() => focusable.focus(), 150);
      }
    }
  }, 100);
};
